import {Box, IconButton, Tooltip, Typography, useTheme} from "@mui/material";
import {StarBorderRounded, StarRounded} from "@mui/icons-material";
import {useState} from "react";
import {useTranslation} from "react-i18next";

const SectionHeader = (props: any) => {
    const {t} = useTranslation();
    const theme = useTheme();
    // @ts-ignore
    const [showToggle] = useState(localStorage.getItem('paths') !== null && (JSON.parse(localStorage.getItem('paths')) as string[]).includes(window.location.pathname));
    const [isFavoritePath, setIsFavouritePath] = useState(window.location.pathname === localStorage.getItem('favoritePath'));
    const handleFavoritePath = () => {
        if (isFavoritePath) {
            localStorage.removeItem('favoritePath');
            setIsFavouritePath(false);
        } else {
            localStorage.setItem('favoritePath', window.location.pathname);
            setIsFavouritePath(true);
        }
    }

    return (
        <Box style={{
            backgroundColor: theme.palette.neutral.main,
            padding: theme.spacing(2),
        }} id={"sectionHeader"}>
            <Typography variant={'h5'} fontWeight={"bold"} color={"primary"} sx={{display:'flex', alignItems:'center'}}>
                {props.title} {showToggle && <IconButton aria-label="favorite" color={'accent'} onClick={handleFavoritePath}>
                {isFavoritePath ? <Tooltip title={t('info.clickToRemoveAsHomepage')}><StarRounded/></Tooltip> :
                    <Tooltip title={t('info.clickToSetAsHomepage')}><StarBorderRounded/></Tooltip>}
            </IconButton>}
            </Typography>
            <Typography variant={'body1'} color={"grey"} component="div">
                {props.subtitle}
            </Typography>
        </Box>
    );
}

export default SectionHeader;
